<template>
    <div class="container">
        <!-- <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="iconfont icon--shebei"></i> 工单中心
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div> -->
        <div class="">
            <div class="handle-box">
                <el-popover ref="popoverRef" placement="bottom-start" width="480" trigger="click" :v-model="true">
                    <el-form ref="searchform" :model="searchform" label-width="120px">
                        <el-form-item label="设备类型">
                            <el-select v-model="searchform.deviceType" placeholder="请选择">
                                <el-option label="智能井盖" value="智能井盖"></el-option>
                                <el-option label="水位流速监测" value="水位流速监测"></el-option>
                                <el-option label="雨量监测" value="雨量监测"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="报警状态">
                            <el-radio :label="0" v-model="searchform.alarmStatus">正常</el-radio>
                            <el-radio :label="1" v-model="searchform.alarmStatus">报警</el-radio>
                        </el-form-item>
                        <el-form-item label="维护状态">
                            <el-radio label="0" v-model="searchform.maintain">正常</el-radio>
                            <el-radio label="1" v-model="searchform.maintain">维护</el-radio>
                        </el-form-item>
                        <el-form-item label="信号强度">
                            <el-col :span="11">
                                <el-input v-model="searchform.rssi1" type="number" placeholder="信号强度范围"></el-input>
                            </el-col>
                            <el-col class="line" :span="2">-</el-col>
                            <el-col :span="11">
                                <el-input v-model="searchform.rssi2" type="number" placeholder="信号强度范围"></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="小区ID">
                            <el-input v-model="searchform.cellID" type="number" placeholder="请输入物理小区ID"></el-input>
                        </el-form-item>
                        <el-form-item label="物理小区标识">
                            <el-input v-model="searchform.pci" type="number" placeholder="请输入物理小区标识"></el-input>
                        </el-form-item>
                        <el-form-item label="软件版本">
                            <el-input v-model="searchform.software" placeholder="请输入软件版本，例v3.0"></el-input>
                        </el-form-item>
                        <el-form-item label="设备创建时间">
                            <el-col :span="11">
                                <el-date-picker type="datetime" placeholder="开始时间" v-model="searchform.createTime1"
                                    style="width: 100%"></el-date-picker>
                            </el-col>
                            <el-col class="line" :span="2">-</el-col>
                            <el-col :span="11">
                                <el-date-picker type="datetime" placeholder="结束时间" v-model="searchform.createTime2"
                                    style="width: 100%"></el-date-picker>
                            </el-col>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="onSubmit">搜索</el-button>
                            <el-button type="primary" @click="onResetSubmit">重置</el-button>
                            <el-button @click="canaleSubmit">取消</el-button>
                        </el-form-item>
                    </el-form>
                    <!-- <el-button slot="reference" type="primary">
                        条件查找
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>-->
                </el-popover>
                <el-select v-model="query.searchTag" placeholder="地址" class="handle-select ml10">
                    <el-option key="1" label="设备名称" value="deviceName"></el-option>
                    <!-- <el-option key="3" label="派单人姓名" value="projectName"></el-option>
                    <el-option key="4" label="派单人手机号" value="projectName"></el-option>
                    <el-option key="5" label="接警人姓名" value="projectName"></el-option>
                    <el-option key="6" label="接警人手机号" value="projectName"></el-option>-->
                </el-select>
                <el-input v-model="query.searchValue" placeholder="请输入搜索内容" class="handle-input mr10 ml10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button type="primary" icon="el-icon-refresh-right" @click="resetSearch">重置</el-button>
            </div>

            <mscard class="projcetCard">
                <template v-slot:header>
                    <div class="cardTitle">工单列表</div>
                    <!-- <div class="cardTitle">企业列表 - {{ deviceListData[0].projectId }}</div> -->
                </template>
                <template v-slot:body>
                    <table class="projectStyle" cellspacing="0">
                        <tr class="projectHeader" style="text-align: center">
                            <th>设备名称</th>
                            <th>设备别名</th>
                            <th>完成状态</th>
                            <th>派单人姓名</th>
                            <th>派单人手机号</th>
                            <th>接警人姓名</th>
                            <th>接警人手机号</th>
                            <th>派单类型</th>
                            <th>派单备注</th>
                            <th>派单时间</th>
                            <th>确认类型</th>
                            <th>确认备注</th>
                            <th>确认时间</th>
                            <th>操作</th>
                        </tr>
                        <tr v-for="(item, index) in tableData" :key="index"
                            :class="selectDevice == index ? 'projectBody selcetBgc' : 'projectBody'"
                            style="text-align: center">
                            <td>{{ item.deviceName }}</td>
                            <td>{{ item.anotherName ? item.anotherName : '未设置' }}</td>
                            <td>{{ item.successType ? '完成' : '未完成' }}</td>
                            <td>{{ item.createPeopleName }}</td>
                            <td>{{ item.createPeoplePhone }}</td>
                            <td>{{ item.maintainPeopleName }}</td>
                            <td>{{ item.maintainPeoplePhone }}</td>
                            <td>报警</td>
                            <td>{{ item.pushInfo }}</td>
                            <td>{{ item.pushtime }}</td>
                            <td>{{ item.confimType ? '报警' : '未确认' }}</td>
                            <td>{{ item.confimInfo ? item.confimInfo : '未确认' }}</td>
                            <td>{{ item.confimtime ? item.confimtime : '未确认' }}</td>
                            <td class="moreDeviceDetail">
                                <el-button type="text" class="red" @click="deleteTask(index, item)">删除</el-button>
                            </td>
                        </tr>
                    </table>
                </template>
            </mscard>

            <!-- <el-table
                :data="tableData"
                :key="tableKey"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column align="center" fixed prop="deviceName" width="120" label="设备名称"></el-table-column>
                <el-table-column align="center" fixed prop="anotherName" width="120" label="设备别名"></el-table-column>
                <el-table-column align="center" fixed prop="successType" width="120" label="完成状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.successType ? 'success' : 'danger'">
                            {{ scope.row.successType ? '完成' : '未完成' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="createPeopleName" width="120" label="派单人姓名"></el-table-column>
                <el-table-column align="center" prop="createPeoplePhone" width="120" label="派单人手机号"></el-table-column>
                <el-table-column align="center" prop="maintainPeopleName" width="120" label="接警人姓名"></el-table-column>
                <el-table-column align="center" prop="maintainPeoplePhone" width="120" label="接警人手机号"></el-table-column>
                <el-table-column align="center" prop="pushType" width="120" label="派单类型">
                    <template slot-scope="scope">报警</template>
                </el-table-column>
                <el-table-column align="center" prop="pushInfo" width="120" label="派单备注"></el-table-column>
                <el-table-column align="center" prop="pushtime" width="120" label="派单时间"></el-table-column>
                <el-table-column align="center" prop="confimType" width="120" label="确认类型">
                    <template slot-scope="scope">
                        {{ scope.row.confimType ? '报警' : '未确认' }}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="confimInfo" width="120" label="确认备注">
                    <template slot-scope="scope">
                        {{ scope.row.confimInfo ? scope.row.confimInfo : '未确认' }}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="confimtime" width="120" label="确认时间"></el-table-column>

                <el-table-column label="操作" width="90" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" class="red" @click="deleteTask(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table> -->
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="query.pageIndex"
                    :page-size="query.pageSize" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
            </div>
        </div>

        <el-dialog title="编辑" :visible.sync="editVisible" width="30%">
            <el-form label-width="70px">
                <el-form-item label="经度">
                    <el-input v-model="editLongitude" placeholder="请输入经度"></el-input>
                </el-form-item>
                <el-form-item label="纬度">
                    <el-input v-model="editLatitude" placeholder="请输入纬度"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEditLocation">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { GetAllDeviceListLimit, UpdateDeviceLocation, UpdateProjectName, CondProjectDevice, ChangeMaintain } from '../../api/index';
import { SearchATask, GetDeviceDetailProjcetDeviceName, QueryUser, QueryMaintainUser, DeleteTask } from '../../api/index';
import mscard from '@/components/common/dashBoard/msCard.vue';
import moment from 'moment';
export default {
    name: 'basetable',
    data() {
        return {
            tableKey: 0,
            searchform: {
                deviceType: '智能井盖',
                alarmStatus: 0,
                maintain: '0',
                rssi1: '',
                rssi2: '',
                cellID: '',
                pci: '',
                software: '',
                createTime1: '',
                createTime2: ''
            },
            // 编辑项目名称值
            editLongitude: '',
            editLatitude: '',
            editDeviceId: '',
            projectId: '',
            query: {
                searchTag: 'deviceName',
                searchValue: '',
                pageIndex: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1
        };
    },

    activated() {

        this.getData();
        this.projectId = this.$route.query.projectId;
    },
    created() {
        this.getData();
        this.projectId = this.$route.query.projectId;
    },
    methods: {
        // 删除工单
        async deleteTask(index, row) {
            this.$confirm('此操作将永久删除该条工单信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    await DeleteTask({
                        id: row.id
                    });
                    this.tableData = this.tableData.filter((item) => {
                        if (item.id !== row.id) {
                            return item;
                        }
                    });
                    this.pageTotal = this.tableData.length;
                    this.$message.success('删除成功');
                    // this.getData();
                })
                .catch(() => { });
        },

        // 重置条件搜索
        onResetSubmit() {
            this.searchform = {
                deviceType: '智能井盖',
                alarmStatus: 0,
                maintain: '0',
                rssi1: '',
                rssi2: '',
                cellID: '',
                pci: '',
                software: '',
                createTime1: '',
                createTime2: ''
            };
            console.log(this.searchform);

            this.getData();
        },
        // 取消条件搜索
        canaleSubmit() {
            this.searchform = {
                deviceType: '智能井盖',
                alarmStatus: 0,
                maintain: '0',
                rssi1: '',
                rssi2: '',
                cellID: '',
                pci: '',
                software: '',
                createTime1: '',
                createTime2: ''
            };
            this.$refs['popoverRef'].doClose();
        },
        // 重置搜索条件
        resetSearch() {
            this.query = {
                searchTag: 'deviceName',
                searchValue: '',
                pageIndex: 1,
                pageSize: 10
            };
            this.searchform = {
                deviceType: '智能井盖',
                alarmStatus: 0,
                maintain: '0',
                rssi1: '',
                rssi2: '',
                cellID: '',
                pci: '',
                software: '',
                createTime1: '',
                createTime2: ''
            };
            this.getData();
        },
        async onSubmit() {
            console.log('submit!');
            this.$set(this.query, 'pageIndex', 1);
            let searchform = JSON.parse(JSON.stringify(this.searchform));
            searchform.cellID = this.searchform.cellID ? this.searchform.cellID : 99999999;
            searchform.createTime1 = new Date(this.searchform.createTime1).getTime() ? new Date(this.searchform.createTime1).getTime() : 0;
            searchform.createTime2 = new Date(this.searchform.createTime2).getTime()
                ? new Date(this.searchform.createTime2).getTime()
                : new Date().getTime();
            searchform.maintain = this.searchform.maintain;
            searchform.pci = this.searchform.pci ? this.searchform.pci : 99999999;
            searchform.rssi1 = this.searchform.rssi1 ? this.searchform.rssi1 : -200;
            searchform.rssi2 = this.searchform.rssi2 ? this.searchform.rssi2 : 200;
            searchform.software = this.searchform.software.trim() ? this.searchform.software.trim() : '%';

            searchform.alarmStatus = this.searchform.alarmStatus;
            // 开始搜索
            let newArr = this.tableData.filter((item, index) => {
                // 判断设备类型是否否合
                if (item.deviceType != searchform.deviceType) {
                    return;
                }
                // 判断报警状态是否符合
                if (item.alarmStatus != searchform.alarmStatus) {
                    return;
                }
                // 判断维护状态是否符合
                if (item.maintain !== searchform.maintain) {
                    return;
                }
                // 判断信号强度是否符合
                if (searchform.rssi1 > item.rssi || searchform.rssi2 < item.rssi) {
                    return;
                }
                // 判断小区ID是否符合
                if (searchform.cellID !== 99999999 && item.cellID.toString().indexOf(searchform.cellID.toString()) === -1) {
                    return;
                }
                // 判断物理小区标识是否符合
                if (searchform.pci !== 99999999 && item.pci.toString().indexOf(searchform.pci.toString()) === -1) {
                    return;
                }
                // 判断软件版本是否符合
                if (searchform.software !== '%' && item.software.indexOf(searchform.software) === -1) {
                    return;
                }
                // 判断创建时间是否符合
                if (searchform.createTime1 > item.createTime * 1 || searchform.createTime2 < item.createTime * 1) {
                    return;
                }
                return item;
            });
            this.tableData = newArr;
            this.pageTotal = newArr.length;
            this.$refs['popoverRef'].doClose();
            return;

            const result = await CondProjectDevice(searchform);

            if (result.code !== 200) {
                return;
            }
            let data = result.data;

            this.pageTotal = data.count;

            let dataArr = [];
            for (let i = 0; i < data.rows.length; i++) {
                let obj = data.rows[i];
                obj.createtime = moment(data.rows[i].createTime * 1).format('YYYY-MM-DD HH:mm:ss');
                obj.updatetime = moment(data.rows[i].updateTime * 1).format('YYYY-MM-DD HH:mm:ss');
                dataArr.push(obj);
            }
            this.tableData = dataArr;
            this.$refs['popoverRef'].doClose();
        },

        // 获取数据
        async getData() {
            const searchResult = await SearchATask({
                searchTag: this.query.searchTag,
                searchValue: this.query.searchValue ? this.query.searchValue : '%',
                companyId: JSON.parse(localStorage.getItem('companyInfo')).companyId,
                limit: this.query.pageSize,
                offset: this.query.pageIndex - 1
            });
            console.log(searchResult);
            const data = searchResult.data.rows;
            this.pageTotal = searchResult.data.count;

            let dataArr = [];
            for (let i = 0; i < data.length; i++) {
                let obj = data[i];
                obj.createtime = moment(data[i].createTime * 1).format('YYYY-MM-DD HH:mm:ss');
                obj.updatetime = moment(data[i].updateTime * 1).format('YYYY-MM-DD HH:mm:ss');
                obj.pushtime = data[i].pushTime ? moment(data[i].pushTime * 1).format('YYYY-MM-DD HH:mm:ss') : '未确认';
                obj.confimtime = data[i].confimTime ? moment(data[i].confimTime * 1).format('YYYY-MM-DD HH:mm:ss') : '未确认';
                // 查找设备信息
                let deviceInfo = await GetDeviceDetailProjcetDeviceName({
                    projectId: data[i].projectId,
                    deviceName: data[i].deviceName
                });

                obj.anotherName = deviceInfo.data.anotherName;
                // 查找派单人信息
                let userInfo = await QueryUser({
                    userId: data[i].createPeopleId
                });
                obj.createPeopleName = userInfo.data.name;
                obj.createPeoplePhone = userInfo.data.phone;
                // 查找接警人信息
                let maintainInfo = await QueryMaintainUser({
                    userId: data[i].maintainPeopleId
                });
                console.log('maintainInfo');
                console.log(maintainInfo);
                obj.maintainPeopleName = maintainInfo.data.name;
                obj.maintainPeoplePhone = maintainInfo.data.phone;

                dataArr.push(obj);
            }
            this.tableData = dataArr;
            this.tableKey++;
            console.log(this.tableData);
        },

        // 打开编辑弹窗
        async editLocationF(index, row) {
            this.editVisible = true;
            console.log(row);
            this.editLongitude = row.longitude;
            this.editLatitude = row.latitude;
            this.editDeviceId = row.id;
        },
        // 保存编辑值
        async saveEditLocation() {
            const result = await UpdateDeviceLocation({
                id: this.editDeviceId,
                longitude: this.editLongitude,
                latitude: this.editLatitude,
                projectId: this.projectId
            });
            this.$message.success('修改成功');
            this.editVisible = false;
            this.getData();
        },

        // 跳转项目绑定企业详情
        async goProjectBind(index, row) {
            this.$router.push(`AProjectBind?projectId=${row.projectId}`);
        },

        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            // let newArr = this.tableData.filter(item => {
            //     console.log(item.deviceName.indexOf(this.query.searchValue));
            //     if (item.deviceName.indexOf(this.query.searchValue) == -1) {
            //         return;
            //     }
            //     return item;
            // });
            // console.log(newArr);
            // this.tableData = newArr;
            // this.pageTotal = newArr.length;
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    this.$message.success('删除成功');
                    this.tableData.splice(index, 1);
                })
                .catch(() => { });
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ' ';
            }
            this.$message.error(`删除了${str}`);
            this.multipleSelection = [];
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            this.form = row;
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
            this.editVisible = false;
            this.$message.success(`修改第 ${this.idx + 1} 行成功`);
            this.$set(this.tableData, this.idx, this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    },
    components: {
        mscard
    }
};
</script>

<style scoped lang="less">
@import '../../assets/css/variables.less';

// 修改弹窗样式 ---开始--
/deep/ .el-dialog__header {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-dialog__title {
    color: #fff;
}

/deep/ .el-dialog__body {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-dialog__footer {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-table th {
    background-color: @black-two !important;
    color: @gray-one;
}

/deep/ .el-table tr {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-table tr:hover {
    background: @black-three !important;
}

/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
    background: none;
}

/deep/ .el-table__empty-block {
    background-color: @black-two;

    border: none;
}

/deep/ .el-table__empty-text {
    color: #fff;
}

/deep/ .el-button--text {
    color: @gray-one;
}

/deep/ .el-button--text:hover {
    color: #fff;
}

/deep/ .el-button--primary {
    background-color: @black-three;
    color: #fff;
    border: none;
    transition: all 0.5s;
}

/deep/ .el-button--primary:hover {
    background-color: #fff;
    color: @black-three;
    border: none;
}

/deep/ .el-dialog__headerbtn .el-dialog__close:hover {
    color: #fff;
}

/deep/ .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
    border: none !important;
}

// 修改弹窗样式 ---结束--
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.ml10 {
    margin-left: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-row {
    margin-bottom: 20px;
}

.grid-content {
    display: flex;
    align-items: center;
    height: 100px;
}

.grid-cont-right {
    flex: 1;
    text-align: center;
    font-size: 14px;
    color: #999;
}

.grid-num {
    font-size: 30px;
    font-weight: bold;
}

.grid-con-icon {
    font-size: 50px;
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    color: #fff;
}

.grid-con-1 .grid-con-icon {
    background: rgb(45, 140, 240);
}

.grid-con-1 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-2 .grid-con-icon {
    background: rgb(100, 213, 114);
}

.grid-con-2 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-3 .grid-con-icon {
    background: rgb(242, 94, 67);
}

.grid-con-3 .grid-num {
    color: rgb(242, 94, 67);
}

.user-info {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 2px solid #ccc;
    margin-bottom: 20px;
}

.user-avator {
    width: 120px;
    height: 120px;
    border-radius: 50%;
}

.user-info-cont {
    padding-left: 50px;
    flex: 1;
    font-size: 14px;
    color: #999;
}

.user-info-cont div:first-child {
    font-size: 30px;
    color: #222;
}

.user-info-list {
    font-size: 14px;
    color: #999;
    line-height: 25px;
}

.user-info-list span {
    margin-left: 70px;
}

.mgb20 {
    margin-bottom: 20px;
}

.todo-item {
    font-size: 14px;
}

.todo-item-del {
    text-decoration: line-through;
    color: #999;
}

.schart {
    width: 100%;
    height: 300px;
}

.line {
    text-align: center;
}
</style>
